module.exports = __webpack_public_path__ + "img/deo.b5bd8e7b.jpg";